import { CourseDef } from '../../../../types';
import L2078941 from './2078941';
import L2079344 from './2079344';
import L2079345 from './2079345';
// import L5232904 from './5232904';
import L5472570 from './5472570';
import L2079346 from './2079346';
import L3893608 from './3893608';
import L2079348 from './2079348';
import L5232905 from './5232905';

export const comecandoNasOpcoesBinarias: CourseDef = {
  courseTitle: 'COMEÇANDO NAS OPÇÕES BINÁRIAS',
  lessons: [
    L2078941,
    L2079344,
    L2079345,
    // L5232904,
    L5472570,
    L2079346,
    L3893608,
    L2079348,
    L5232905,
  ],
};

